var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResizeCorner = function SvgResizeCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0328 17.1563C17.9826 17.6514 17.564 18.0376 17.0557 18.0376L9.65099 18.0376C9.10879 18.0376 8.66936 17.5982 8.66936 17.056C8.66936 16.5138 9.10879 16.0744 9.65099 16.0744L16.0741 16.0744L16.0741 9.65131C16.0741 9.10911 16.5135 8.66968 17.0557 8.66968C17.5979 8.66968 18.0373 9.10911 18.0373 9.65131L18.0373 17.056L18.0328 17.1563Z",
    fill: "currentColor"
  })));
};
export default SvgResizeCorner;